import { render, staticRenderFns } from "./BlockOne.vue?vue&type=template&id=0ec56b80&scoped=true&"
import script from "./BlockOne.vue?vue&type=script&lang=js&"
export * from "./BlockOne.vue?vue&type=script&lang=js&"
import style0 from "./BlockOne.vue?vue&type=style&index=0&id=0ec56b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec56b80",
  null
  
)

export default component.exports